import { connect, ConnectedProps } from 'react-redux';
import { AppState } from '../../interfaces';
import { API_KEYS } from '../../interfaces/api';
import { getApiState } from '../../redux/selectors/common';
import { showModal, hideModal } from '../../redux/slices/modal';
import { resetApiThunk, logOut } from '../../redux/thunks/api';
import { thunks } from '../../redux/thunks/thunks';
import AuthHeaderMenu from './AuthHeaderMenu';

const mapState = (state: AppState) => ({
  auth: getApiState(state, API_KEYS.LOGIN),
  notifications: getApiState(state, API_KEYS.GET_NOTIFICATIONS),
  walletpinstatus : getApiState(state, API_KEYS.GET_WALLETPIN_STATUS),
  resetApi: resetApiThunk,
});

const mapDispatch = {
  showModal,
  resetApiThunk,
  getWalletPinStatus: thunks.GET_WALLETPIN_STATUS,
  getNotifications: thunks.GET_NOTIFICATIONS,
  updateNotification: thunks.UPDATE_NOTIFICATION,
  logOut,
};

const connector = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(AuthHeaderMenu);
